import { addYears, parse } from 'date-fns';
import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { parseHighlightedDates, parseSelectedDays } from '../utils';
import { MonthsWrapper } from './MonthsWrapper/MonthsWrapper';
export const minDefaultDate = '1910-01-01';
const RendererFunctions = {
    dayRenderer(date, className) {
        return React.createElement("div", { className: className }, date.getDate());
    },
    monthRenderer(params) {
        return (React.createElement(React.Fragment, null,
            params.monthHeader,
            params.weeklyHeader,
            React.createElement("div", { className: params.monthClassName }, params.daysByWeeks.map((day, index) => (React.createElement("div", { key: index, className: params.weekClassName }, day))))));
    },
    monthHeaderAsPlainText: true
};
export const RendererFunctionsContext = React.createContext(RendererFunctions);
export const Datepicker = props => {
    const monthCount = props.monthCount ? props.monthCount : 1;
    const initialDate = props.openDate ? props.openDate : new Date();
    const css = useTheme('Datepicker').PopupDatepickerStyles;
    const customFunctionsRenderer = Object.assign({}, RendererFunctions);
    if (props.dayRenderer) {
        customFunctionsRenderer.dayRenderer = props.dayRenderer;
    }
    if (props.monthRenderer) {
        customFunctionsRenderer.monthRenderer = props.monthRenderer;
    }
    customFunctionsRenderer.monthHeaderAsPlainText = !props.monthHeaderAsSelector;
    return (React.createElement("div", { className: cn(css.block, props.className), ref: props.getRef ? props.getRef : null },
        props.children && React.createElement("div", null, props.children),
        React.createElement(RendererFunctionsContext.Provider, { value: customFunctionsRenderer },
            React.createElement(MonthsWrapper, { getParentRef: props.getParentRef, initialDate: initialDate, monthCount: monthCount, monthsToScroll: props.monthsToScroll, monthBaseDateVariant: props.monthBaseDateVariant, onSelect: props.onSelect, onHover: props.onHover, hoverDates: props.hoverDates, minDate: props.minDate ? props.minDate : parse(minDefaultDate, 'yyyy-MM-dd', new Date()), maxDate: props.maxDate ? props.maxDate : addYears(initialDate, 1), selectedDates: parseSelectedDays(props.selectedDates ? props.selectedDates : []), highlightedDates: parseHighlightedDates(props.highlightedDates), frameless: props.frameless, monthsHeader: props.monthsHeader }))));
};
export default Datepicker;
